export default [
  {
    name: "starTexture",
    type: "texture",
    path: "textures/5.png",
  },

  {
    name: "skyTexture",
    type: "exr",
    path: "textures/skyTexture.exr",
  },

  // {
  //   name: "font",
  //   type: "font",
  //   path: "helvetiker_regular.typeface.json",
  // },
];
